import { getApiUrl } from '@/shared/utils/helpers';
import Vue from 'vue';
export async function getAllNotes(companyId) {
    return await Vue.axios.get(`${getApiUrl()}/user/notes/${companyId}`);
}
export async function createNewNote(data) {
    return await Vue.axios.post(`${getApiUrl()}/user/notes/`, data);
}
export async function deleteNote(id) {
    return await Vue.axios.delete(`${getApiUrl()}/user/notes/${id}`);
}
export async function getAnnotationCategories() {
    return await Vue.axios.get(`${getApiUrl()}/account_preferences/keywords_available`);
}
export async function getRecordCategories(userId) {
    let path = `${getApiUrl('v3')}/record_app/categories`;
    if (userId)
        path += `?user_id=${userId}`;
    return await Vue.axios.get(path);
}
export async function createRecordCategory(name) {
    return await Vue.axios.post(`${getApiUrl('v3')}/record_app/categories`, {
        name,
    });
}
export async function deleteRecordCategory(id) {
    return await Vue.axios.delete(`${getApiUrl('v3')}/record_app/categories/${id}`);
}
export async function saveUserProspectingLog(infosetId, companyId, data) {
    return await Vue.axios.post(`${getApiUrl('v3')}/info_sets/${infosetId}/company/${companyId}/user_prospecting_log`, data);
}
export async function getUserProspectingLogs(infosetId, companyId) {
    return await Vue.axios.get(`${getApiUrl('v3')}/info_sets/${infosetId}/company/${companyId}/user_prospecting_log`);
}
export async function deleteUserProspectingLog(infosetId, companyId, logId) {
    return await Vue.axios.delete(`${getApiUrl('v3')}/info_sets/${infosetId}/company/${companyId}/user_prospecting_log/${logId}`);
}
